import { GerarImagemUsuario } from "../../../api/controllers/optiGenerator";

export default class IAGeneratorTune {
    static get toolbox() {
        return {
            title: "Gerar Imagem com IA",
            icon: `<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M12 6v6l4 2"></path>
        </svg>`
        };
    }

    constructor({ data, api }) {
        this.api = api;
        this.data = {
            url: data?.url || "",
            caption: data?.caption || ""
        };

        this.wrapper = null;
    }

    render() {
        this.wrapper = document.createElement("div");
        this.wrapper.classList.add("ia-generator-block");

        if (this.data.url) {
            this._renderImage();
        } else {
            const container = document.createElement("div");
            container.className = "upload-placeholder ia-style";

            const svgIcon = `
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#4a4a4a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <path d="M21 15l-5-5L5 21"></path>
            </svg>
          `;

            const iconWrapper = document.createElement("div");
            iconWrapper.innerHTML = svgIcon;
            iconWrapper.style.marginBottom = "8px";

            const text = document.createElement("div");
            text.textContent = "Clique para gerar uma imagem com IA";
            text.style.fontSize = "14px";
            text.style.color = "#4a4a4a";

            container.appendChild(iconWrapper);
            container.appendChild(text);
            container.addEventListener("click", () => this._openModal());

            this.wrapper.appendChild(container);
        }

        return this.wrapper;
    }


    _renderImage() {
        const img = document.createElement("img");
        img.src = this.data.url;
        img.style.maxWidth = "100%";
        img.style.borderRadius = "4px";

        const caption = document.createElement("input");
        caption.type = "text";
        caption.placeholder = "Legenda da imagem";
        caption.value = this.data.caption || "";
        caption.style.width = "100%";
        caption.style.textAlign = "center";
        caption.addEventListener("input", (e) => {
            this.data.caption = e.target.value;
        });

        this.wrapper.appendChild(img);
        this.wrapper.appendChild(caption);
    }

    _openModal() {
        if (document.querySelector(".ia-modal")) return;

        const modal = document.createElement("div");
        modal.className = "ia-modal";
        modal.innerHTML = `
        <div class="ia-modal-overlay"></div>
        <div class="ia-modal-content">
          <h3>Descreva a imagem que deseja gerar</h3>
          <textarea rows="4" placeholder="Ex: Um dragão futurista sobre uma cidade..."></textarea>
          <div class="ia-modal-footer">
            <button class="cancel">Cancelar</button>
            <button style="background-color: #56a55c" class="generate">Gerar</button>
          </div>
        </div>
      `;

        document.body.appendChild(modal);

        const textarea = modal.querySelector("textarea");
        const generateBtn = modal.querySelector(".generate");
        const cancelBtn = modal.querySelector(".cancel");

        cancelBtn.onclick = () => modal.remove();

        generateBtn.onclick = async () => {
            const prompt = textarea.value.trim();
            if (!prompt) return;

            // Fecha o modal antes de gerar a imagem
            modal.remove();

            // Mostra o loading no bloco
            this._showLoading();

            try {
                const imagemBase64 = await this.gerarImagem(prompt);
                this.data.url = `data:image/png;base64,${imagemBase64}`;
                this.data.caption = `Legenda da Imagem`;

                this.wrapper.innerHTML = "";
                this._renderImage();
            } catch (err) {
                console.error("Erro ao gerar imagem:", err);
                this._showError("Erro ao gerar imagem. Tente novamente.");
            }
        };

    }

    _showLoading() {
        this.wrapper.innerHTML = "";

        const loadingContainer = document.createElement("div");
        loadingContainer.className = "loading-placeholder ia-style";
        loadingContainer.style.display = "flex";
        loadingContainer.style.flexDirection = "column";
        loadingContainer.style.alignItems = "center";
        loadingContainer.style.justifyContent = "center";
        loadingContainer.style.padding = "40px";
        loadingContainer.style.color = "#666";
        loadingContainer.style.fontSize = "14px";

        const spinner = document.createElement("div");
        spinner.innerHTML = `
        <style>
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .spinner-circle {
            animation: spin 1s linear infinite;
            transform-origin: center;
          }
        </style>
        <svg width="32" height="32" viewBox="0 0 50 50">
          <circle
            class="spinner-circle"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke="#999"
            stroke-width="5"
            stroke-linecap="round"
            stroke-dasharray="90 150"
            stroke-dashoffset="0"
          />
        </svg>
      `;


        const loadingText = document.createElement("div");
        loadingText.textContent = "Gerando imagem...";

        loadingContainer.appendChild(spinner);
        loadingContainer.appendChild(loadingText);

        this.wrapper.appendChild(loadingContainer);
    }



    async gerarImagem(prompt) {

        var imagembase64;
        await GerarImagemUsuario(prompt).then((response) => {
            imagembase64 = response?.data?.image_bytes;
        });

        return imagembase64;
    }

    save() {
        return this.data;
    }

    validate(savedData) {
        return !!savedData.url;
    }
}
